module.exports = __webpack_public_path__ + "static/media/chargeIcon.7d55f969.svg";